export default __webpack_public_path__ + "static/media/logo-orbit.7d2eed71.svg";